module.exports = __webpack_public_path__ + "static/media/fact_check_white_24dp.dd8b909a.svg";